// extracted by mini-css-extract-plugin
module.exports = {"staggeredImageContainer":"staggered-image-bloc-container_staggeredImageContainer__2pl-S"};